import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { RadiusType } from '@/components/MapOverview/components/MapRadiusContextProvider';
import { NCCardSectionHeader } from '@/components/NCCard/NCCard';

import { ThreatnedSpeciesSummary } from './components/ThreatnedSpeciesSummary';

export const ThreatenedSpeciesStatsTile = ({
  threatenedSpeciesSummary,
  radius,
}: {
  threatenedSpeciesSummary: PlotReportFactElement[];
  radius?: RadiusType;
}) => {
  return (
    <Stack className='gap-8 px-6 py-8 lg:gap-4' data-testid='threatened-species-stats-tile'>
      <ThreatenedSpeciesCount threatenedSpecies={threatenedSpeciesSummary} radius={radius} />
    </Stack>
  );
};

const ThreatenedSpeciesCount = ({
  threatenedSpecies,
  radius,
}: {
  threatenedSpecies: PlotReportFactElement[];
  radius?: RadiusType;
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-8 lg:gap-4'>
      <NCCardSectionHeader
        title={t(
          radius
            ? 'shared.ncaDetail.details.threatenedSpecies.stats.header.titleWithRadius'
            : 'shared.ncaDetail.details.threatenedSpecies.stats.header.titleNoRadius',
          {
            radius,
          },
        )}
        popover={{
          title: t(
            radius
              ? 'shared.ncaDetail.details.threatenedSpecies.stats.header.titleWithRadius'
              : 'shared.ncaDetail.details.threatenedSpecies.stats.header.titleNoRadius',
            {
              radius,
            },
          ),
          body: t('shared.ncaDetail.details.threatenedSpecies.stats.header.tooltipBody'),
        }}
      />
      <Stack className='mt-4 gap-4 rounded-2xl bg-neutral-black-4 px-4 py-6'>
        <span className='typography-body1Bold'>
          {t('shared.ncaDetail.details.threatenedSpecies.stats.explainer.title')}
        </span>
        <ThreatnedSpeciesSummary data={threatenedSpecies} />
      </Stack>
    </div>
  );
};
